import React, { Fragment } from 'react'

import { Helmet } from 'react-helmet'

import HeaderMain from '../components/header-main'
import Component3cards from '../components/component3cards'
import FooterMain from '../components/footer-main'
import './printers.css'

const __staticProp0 = {
  url: '/arctic-white',
  newTab: false,
}

const __staticProp1 = {
  url: '/goldenrod',
  newTab: false,
}

const __staticProp2 = {
  url: '/eminence',
  newTab: false,
}

const Printers = (props) => {
  return (
    <div className="printers-container">
      <Helmet>
        <title>Промышленные 3D-принтеры по металлу WAAM | Arcobo</title>
        <meta
          name="description"
          content="Проектирование производительных 3D-принтеров по металлу под детали клиента. Поставка и внедрение WAAM-систем в Казахстане и Узбекистане."
        />
        <meta
          property="og:title"
          content="Промышленные 3D-принтеры по металлу WAAM | Arcobo"
        />
        <meta
          property="og:description"
          content="Проектирование производительных 3D-принтеров по металлу под детали клиента. Поставка и внедрение WAAM-систем в Казахстане и Узбекистане."
        />
        <meta
          property="og:image"
          content="https://arcobo.tech/og_image.png"
        />
        <meta property="og:type" content="website" />
        <meta
          name="twitter:title"
          content="Промышленные 3D-принтеры по металлу WAAM | Arcobo"
        />
        <meta
          name="twitter:description"
          content="Проектирование производительных 3D-принтеров по металлу под детали клиента. Поставка и внедрение WAAM-систем в Казахстане и Узбекистане."
        />
        <meta
          name="twitter:image"
          content="https://arcobo.tech/og_image.png"
        />
        <link
          rel="canonical"
          href="https://arcobo.tech/printers"
        />
        <meta
          property="og:url"
          content="https://arcobo.tech/printers"
        />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html:
              '{"@context":"https://schema.org","@type":"BreadcrumbList","itemListElement":[{"@type":"ListItem","position":1,"name":"Home","item":"https://arcobo.tech"},{"@type":"ListItem","position":2,"name":"Printers","item":"https://arcobo.tech/printers"}]}',
          }}
        />
      </Helmet>
      <HeaderMain rootClassName="header-mainroot-class-name5"></HeaderMain>
      <hr className="printers-separator1"></hr>
      <Component3cards
        titleAs="h1"
        feature1Url={__staticProp0}
        feature2Url={__staticProp1}
        feature3Url={__staticProp2}
        componentText="Линейка промышленных WAAM-систем для изготовления и восстановления металлических деталей любой сложности"
        feature1Title="ArcticWhite"
        feature2Title="Goldenrod"
        feature3Title="Eminence"
        rootClassName="component3cardsroot-class-name"
        componentTitle="3D-принтеры Arcobo"
        feature1Title2={
          <Fragment>
            <span className="printers-text10">
              <span>Максимальная свобода размеров</span>
              <br className="H1_extrasmall"></br>
              feature1Title
            </span>
          </Fragment>
        }
        feature2Title1="Максимальная эффективность печати"
        feature2Title2={
          <Fragment>
            <span className="printers-text13">Goldenrod</span>
          </Fragment>
        }
        feature3Title1="Максимальные возможности материалов"
        feature3Title2={
          <Fragment>
            <span className="printers-text14">Eminence</span>
          </Fragment>
        }
        feature1ImageSrc="/2_3D Printing/2_3_3D Printers/arcticwhite-1500w.webp"
        feature1ImageAlt="3D-принтер Arcobo ArcticWhite"
        feature2ImageSrc="/2_3D Printing/2_3_3D Printers/goldenrod%201-400h.webp"
        feature2ImageAlt="3D-принтер Arcobo Goldenrod"
        feature3ImageSrc="/2_3D Printing/2_3_3D Printers/eminence_v2-400h.webp"
        feature3ImageAlt="3D-принтер Arcobo Eminence"
        feature1Description={
          <Fragment>
            <span className="printers-text15">
              <span>
                Роботизированная система для печати и восстановления
                крупногабаритных металлических деталей без ограничений рабочей
                камерой.
              </span>
              <span></span>
            </span>
          </Fragment>
        }
        feature2Description="Компактная WAAM-система для изготовления и ремонта деталей до 500 кг и габаритами менее 2 метров в условиях промышленного предприятия."
        feature3Description="Герметичная инертная камера позволяет печатать детали из титана, инконеля и других высокотехнологичных сплавов."
        feature2Description1={
          <Fragment>
            <span className="printers-text18">
              Компактная WAAM-система для изготовления и ремонта деталей до 500
              кг и габаритами менее 2 метров в условиях промышленного
              предприятия.
            </span>
          </Fragment>
        }
        feature3Description1={
          <Fragment>
            <span className="printers-text19">
              Герметичная инертная камера позволяет печатать детали из титана,
              инконеля и других высокотехнологичных сплавов.
            </span>
          </Fragment>
        }
      ></Component3cards>
      <hr className="printers-separator2"></hr>
      <FooterMain rootClassName="footer-mainroot-class-name5"></FooterMain>
    </div>
  )
}

export default Printers
